import React from 'react';
import {
  Text,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Image,
  UnorderedList,
  ListItem,
  Divider,
  Stack,
  Box,
  VStack,
  Container,
  Flex,
  useBreakpointValue,
} from '@chakra-ui/react';

import HomeLayout from '../../components/layouts/homelayout';
import strategyMissionValuesHeroImage from '../../components/ui/ourcompany/strategy-mission-values-hero.png';
import coreValuesStrategy from '../../components/ui/ourcompany/coreValuesStrategy.jpeg';
import HeroWithLeftMedia from '../../components/sections/herowithleftmedia';

export default function StrategyMissionValues() {
  return (
    <HomeLayout align="left">
      <Stack w="full" pt="90px"></Stack>
      <Breadcrumb py={4} fontSize={'xs'} ml="150px" id="breadcrumb">
        <BreadcrumbItem>
          <BreadcrumbLink href="/">Home</BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbItem isCurrentPage={'true'}>
          <BreadcrumbLink fontWeight="bold" href="#">
            Strategy – Mission – Values
          </BreadcrumbLink>
        </BreadcrumbItem>
      </Breadcrumb>
      <Flex
        w={'full'}
        h={'40vh'}
        backgroundImage={strategyMissionValuesHeroImage}
        backgroundSize={'cover'}
        backgroundPosition={'center center'}
        id="strategyMissionValuesHeroImg"
      >
        <VStack
          w={'full'}
          justify={'end'}
          align={'left'}
          px={useBreakpointValue({ base: 4, md: 8 })}
          bgGradient={'linear(to-r, blackAlpha.600, transparent)'}
        >
          <Stack maxW={'2xl'} spacing={6}>
            <Text
              color={'white'}
              fontWeight={600}
              lineHeight={1.2}
              fontSize={useBreakpointValue({
                base: '2xl',
                md: '4xl',
                sm: '3xl',
              })}
              mb="10px"
              id="heroText"
            >
              WE CONNECT ACTIVE PEOPLE WITH THEIR PASSIONS
            </Text>
          </Stack>
        </VStack>
      </Flex>
      <Container maxW="6xl">
        <VStack
          align="left"
          spacing={{ base: 5 }}
          py={{ base: 5, md: 10 }}
          direction={{ base: 'column', md: 'row' }}
        >
          <Divider />
          <Text
            fontSize={{ base: '2xl', sm: '3xl', lg: '4xl' }}
            fontWeight={600}
            id="ourMission"
            align="left"
          >
            OUR MISSION
          </Text>
          <Text id="missionStatement">
            At Columbia Sportswear Company, we're more than just a leader in the
            global active lifestyle apparel, footwear, accessories and equipment
            industry. We connect active people with their passions.
          </Text>
        </VStack>

        <Divider />
        <HeroWithLeftMedia
          media={
            <Image
              borderRadius={10}
              src={coreValuesStrategy}
              id="coreValuesImg"
            />
          }
          title="OUR CORE VALUES"
          subTitle={
            <UnorderedList>
              <ListItem>Enjoy an Active Life</ListItem>
              <ListItem>Compete to Win</ListItem>
              <ListItem>Culture of Honesty, Respect & Trust</ListItem>
              <ListItem>
                Doing the Right Thing for Consumers, Customers, Employees, the
                Company & our Communities
              </ListItem>
            </UnorderedList>
          }
        />
        <Divider />
        <Box>
          <Text
            fontSize={{ base: '2xl', sm: '3xl', lg: '4xl' }}
            fontWeight={600}
            py={4}
            id="strategicPriorities"
            align="left"
          >
            {' '}
            OUR STRATEGIC PRIORITIES
          </Text>
          <Text>
            We are committed to driving long-term sustainable profitable growth.
            Our business momentum and fortress balance sheet enable us to invest
            in our strategic priorities to:
          </Text>
          <UnorderedList py={4}>
            <ListItem>Accelerate profitable growth;</ListItem>
            <ListItem>
              Create iconic products that are differentiated, functional and
              innovative;
            </ListItem>
            <ListItem>
              Drive brand engagement through increased, focused demand creation
              investments;
            </ListItem>
            <ListItem>
              Enhance consumer experiences by investing in capabilities to
              delight and retain consumers;
            </ListItem>
            <ListItem>
              Amplify marketplace excellence with a digitally-led, omni-channel
              global distribution; and
            </ListItem>
            <ListItem>
              Empower talent that is driven by our core values through a diverse
              and inclusive workforce.
            </ListItem>
          </UnorderedList>
        </Box>
      </Container>
    </HomeLayout>
  );
}
